import { useTypedQuery } from "hooks";
import { useDevicesFilters } from "modules/DevicesDashboard/components/DevicesDashboardFilters/hooks";
import { DevicesDashboardQueryKeys } from "modules/DevicesDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDevicesQuery = () => {
  const filters = useDevicesFilters();

  return useTypedQuery({
    queryKey: DevicesDashboardQueryKeys.devices,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, filters, baseUrl)).data,
    refetchOnDependencies: [filters]
  });
};
